module.exports = __webpack_public_path__ + "static/media/makeAMove_en.922271ab.svg";